export default {
    newJerseyName: 'NJ',
    homepagePreloaderInitialDelay: 9000,
};
